export default "__VITE_ASSET__SZ$tXfW9__"